import { apiClient } from "../api/apiClient";
import { Status, CreateStatusRequest, UpdateStatusRequest } from "../interfaces/Status";

type ResponseDto<T> = {
  loggingHistoryID?: number;
  statusCode: number;
  isSuccess: boolean;
  message: string;
  errors?: string[];
  data?: T;
  dataList?: T[];
};

export const statusService = {
  getAll: async (): Promise<ResponseDto<Status>> => {
    const response = await apiClient.get<ResponseDto<Status>>("/Statuses/GetAll");
    return response.data;
  },
  getById: async (statusID: number): Promise<ResponseDto<Status>> => {
    const response = await apiClient.get<ResponseDto<Status>>(`/Statuses/GetById/${statusID}`);
    return response.data;
  },
  create: async (payload: CreateStatusRequest): Promise<ResponseDto<Status>> => {
    const response = await apiClient.post<ResponseDto<Status>>("/Statuses/Create", payload);
    return response.data;
  },
  update: async (payload: UpdateStatusRequest): Promise<ResponseDto<Status>> => {
    const response = await apiClient.put<ResponseDto<Status>>(`/Statuses/Update/${payload.statusID}`, payload);
    return response.data;
  },
  delete: async (statusID: number): Promise<ResponseDto<any>> => {
    const response = await apiClient.delete<ResponseDto<any>>(`/Statuses/Delete/${statusID}`);
    return response.data;
  },
};
